'use strict';

import Async from 'async';
import _ from 'lodash';

export default class ExportModalController {
  /*@ngInject*/
  constructor($http, $q, $timeout, $filter, $uibModalInstance) {
    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.$uibModalInstance = $uibModalInstance;

    this.isAdd = true;
    this.form = {};
  }

  formatDate(dt) {
    if(dt) {
      console.log(dt);
      return this.$filter('date')(dt, 'yyyy-MM-dd');
    }
    return null;
  }

  submitForm() {
    return null;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');

  }
}



// WEBPACK FOOTER //
// ./client/app/order/export.modal.controller.js